import { render, staticRenderFns } from "./passengers.vue?vue&type=template&id=2bdffa4e"
import script from "./passengers.vue?vue&type=script&lang=js"
export * from "./passengers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports